export const NAME_MAX_LENGTH = 25;
export const TABNAME_MAX_LENGTH = 40;
export const DASHBOARD_PREFIX = 'dashboard-';
export const BASIC_DATA_TABLE_DISPLAY_ROWS = 20;

// Max items per widget
export const BASIC_DATA_TABLE_MAX_ITEMS = 30;
export const SPOT_CHART_MAX_ITEMS = 6;
export const SEASONAL_CHART_MAX_ITEMS = 1;
export const FWD_CHART_MAX_ITEMS = 2;
export const HIGHLIGHTED_PRICE_MAX_ITEMS = 8;

export const SHARE_DASHBOARD_EMAIL_TEMPLATE = 'go_share_dashboard_url.ftl';
export const SHARE_TOKEN_PARAM = 'shareToken';

// Dashboard sharing route paths
export const SHARED_DASHBOARD_PATH = '/shared-dashboard';
export const SHARED_DASHBOARD_NOT_FOUND_PATH = '/dashboard-share-not-found';
export const SHARED_DASHBOARD_EXPIRED_PATH = '/dashboard-share-expired';
